"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export function FinalCTA() {
    return (
        <section className="py-24 px-4 bg-background">
            <div className="container mx-auto max-w-5xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="relative rounded-2xl overflow-hidden border border-border"
                >
                    {/* Card with theme-aware styling */}
                    <div className="relative bg-card p-12 md:p-20">
                        {/* Subtle grid pattern */}
                        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:24px_24px]" />

                        <div className="relative z-10 text-center">
                            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-foreground">
                                ready to ship
                                <br />
                                better code?
                            </h2>
                            <p className="text-lg md:text-xl text-muted-foreground max-w-xl mx-auto mb-10">
                                join hundreds of teams shipping secure code faster.
                                start for free today.
                            </p>
                            <Link href="/sign-up">
                                <Button
                                    size="lg"
                                    className="h-12 px-8 rounded-lg text-base bg-foreground text-background cursor-pointer hover:bg-foreground/90 font-medium"
                                >
                                    get started free
                                    <ArrowRight className="ml-2 h-4 w-4" />
                                </Button>
                            </Link>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
